import { apiInstance} from '../apiInstance';
import { ApiRoutes } from '../apiRoutes';

export const getDisputedReasons = async () => {
    const response = await apiInstance.get(ApiRoutes.DisputedReasons);
    return response.data;
};
